import BeehiveImage from './BeehiveImage';

export default BeehiveImage;
